import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetPostContentOffersReset, EGetPostContentOffersActionType } from './types';

export const getPostContentOffersReset: () => TGetPostContentOffersReset =
  actionGenerator<EGetPostContentOffersActionType.Reset>(EGetPostContentOffersActionType.Reset);
